<!-- Welcome -->
<div class="welcome-card">
    <div>
        <h2 style="font-weight: normal;">Welcome Back, <span style="font-weight: 600;">{{user.name}}</span>
            ({{user.position}})</h2>
        <p>Manage your classes, students, attendance and assignments efficiently.</p>
    </div>

    <button class="btn btn-primary">
        <i class="bi bi-plus-circle"></i>
        Create Assignment
    </button>
</div>

<!-- KPI Cards -->
<div class="row g-3 mt-0 mb-3">
  <div class="col-xl-2 col-md-6">
    <div class="kpi-card">
      <div class="d-flex justify-content-between">
        <i class="bi bi-person-lines-fill text-primary me-3"></i>
        <h1>24</h1>
      </div>
      <div class="text-end">Inquiries</div>
    </div>
  </div>

  <div class="col-xl-2 col-md-6">
    <div class="kpi-card">
      <div class="d-flex justify-content-between">
        <i class="bi bi-file-earmark-text text-warning me-3"></i>
        <h1>18</h1>
      </div>
      <div class="text-end">Applications</div>
    </div>
  </div>

  <div class="col-xl-2 col-md-6">
    <div class="kpi-card">
      <div class="d-flex justify-content-between">
        <i class="bi bi-person-check text-success me-3"></i>
        <h1>17</h1>
      </div>
      <div class="text-end">Admissions</div>
    </div>
  </div>

  <div class="col-xl-2 col-md-6">
    <div class="kpi-card">
      <div class="d-flex justify-content-between">
        <i class="bi bi-person-workspace text-info me-3"></i>
        <h1>11</h1>
      </div>
      <div class="text-end">Follow-Ups</div>
    </div>
  </div>

  <div class="col-xl-2 col-md-6">
    <div class="kpi-card">
      <div class="d-flex justify-content-between">
        <i class="bi bi-person-slash text-danger me-3"></i>
        <h1>1</h1>
      </div>
      <div class="text-end">On Hold</div>
    </div>
  </div>

  <div class="col-xl-2 col-md-6">
    <div class="kpi-card">
      <div class="d-flex justify-content-between">
        <i class="bi bi-person-exclamation text-danger me-3"></i>
        <h1>3</h1>
      </div>
      <div class="text-end">Overdue</div>
    </div>
  </div>

</div>

<!-- Main Widgets -->
<div class="row g-3 mb-3">
  <div class="col-lg-8">
    <div class="dashboard-card">
      <div class="card-header-custom">
        Upcoming Counselling Sessions
      </div>

      <div class="table-responsive">
        <table class="table align-middle">
          <thead>
            <tr>
              <th>Student</th>
              <th>Class</th>
              <th>Time</th>
              <th>Reason</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Aryan Sharma</td>
              <td>X-A</td>
              <td>10:00 AM</td>
              <td>Academic Stress</td>
              <td><span class="badge bg-success">Confirmed</span></td>
            </tr>

            <tr>
              <td>Riya Verma</td>
              <td>IX-B</td>
              <td>11:30 AM</td>
              <td>Behavioural Support</td>
              <td><span class="badge bg-warning">Pending</span></td>
            </tr>

            <tr>
              <td>Karan Singh</td>
              <td>XI-C</td>
              <td>02:00 PM</td>
              <td>Career Guidance</td>
              <td><span class="badge bg-primary">Scheduled</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="col-lg-4">
    <div class="dashboard-card p-3" style="min-height: 250px;">
      <h5><i class="bi bi-check2-square"></i> Todo List</h5>
      <hr class="mt-0">
      <app-todo [stats]="false"  [title]="false"></app-todo>
    </div>
  </div>

  <div class="col-lg-4">
    <div class="dashboard-card">
      <div class="card-header-custom">
        Student Wellness Summary
      </div>

      <div class="summary-row">
        <span>Excellent</span>
        <strong>68%</strong>
      </div>

      <div class="summary-row">
        <span>Good</span>
        <strong>27%</strong>
      </div>

      <div class="summary-row">
        <span>Moderate</span>
        <strong>24%</strong>
      </div>

      <div class="summary-row">
        <span>Needs Attention</span>
        <strong>8%</strong>
      </div>
    </div>
  </div>

  <div class="col-lg-4">
    <div class="dashboard-card">
      <div class="card-header-custom">
        Career Guidance Requests
      </div>

      <div class="summary-row">
        <span>Engineering</span><strong>45</strong>
      </div>
      <div class="summary-row">
        <span>Medical</span><strong>22</strong>
      </div>
      <div class="summary-row">
        <span>Commerce</span><strong>18</strong>
      </div>
      <div class="summary-row">
        <span>Arts</span><strong>12</strong>
      </div>
      <div class="summary-row">
        <span>Other</span><strong>7</strong>
      </div>
    </div>
  </div>

  <div class="col-lg-4">
    <div class="dashboard-card">
      <div class="card-header-custom">
        Parent Meetings
      </div>

      <ul class="meeting-list">
        <li>10:30 AM - Grade IX Parent</li>
        <li>01:00 PM - Grade X Parent</li>
        <li>03:30 PM - Grade XII Parent</li>
      </ul>
    </div>
  </div>

  <div class="col-12">
    <div class="dashboard-card">
      <div class="card-header-custom">
        Recent Referrals & Behaviour Reports
      </div>

      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>Student</th>
              <th>Class</th>
              <th>Reported By</th>
              <th>Issue</th>
              <th>Priority</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Rahul Kumar</td>
              <td>12th Class</td>
              <td>Class Teacher</td>
              <td>Attendance Concern</td>
              <td><span class="badge bg-warning">Medium</span></td>
            </tr>

            <tr>
              <td>Sneha Sharma</td>
              <td>12th Class</td>
              <td>Vice Principal</td>
              <td>Behaviour Concern</td>
              <td><span class="badge bg-danger">High</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
